'use client';

import { useEffect } from 'react';
import { useUnsavedChanges } from '@/context/UnsavedChangesProvider';

/**
 * Custom hook to synchronize a form's dirty state with the UnsavedChangesContext.
 * @param isFormDirty - Boolean indicating if the form has unsaved changes.
 */
export const useFormUnsavedChanges = (isFormDirty: boolean) => {
  const { markAsDirty, markAsClean } = useUnsavedChanges();

  useEffect(() => {
    if (isFormDirty) {
      markAsDirty();
    } else {
      markAsClean();
    }
  }, [isFormDirty, markAsDirty, markAsClean]);
};
